__turbopack_context__.v({
  "root": "rte-module-scss-module__k9tsKW__root",
  "toolbar": "rte-module-scss-module__k9tsKW__toolbar",
});
